import React from "react";
import {Check, Loading2} from "assets/icons";
import Banner from "components/banner/banner";
import Button from "components/button";
import Importfile from "components/formcomponents/importfile";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";

const CONDITIONS = ["readable", "whole", "end_date"];

const DocumentImportStep = ({
    translate,
    documentType,
    files,
    onFileChange,
    canImport,
    isUploading,
    errorMessage,
    onBack,
    onClose,
    onImport,
}) => {
    const needsBothSides = documentType === "new_permit";

    return (
        <>
            <Modalheader hide={onClose} hideShow={!isUploading}>
                {translate(`options.${documentType}.title`)}
            </Modalheader>
            <ModalBody>
                {isUploading ? (
                    <div className="flex flex-col items-center justify-center gap-4 py-12" role="status" aria-live="polite">
                        <div className="animate-spin">
                            <Loading2 wh={48}/>
                        </div>
                        <p className="ft-b text-gray-700 text-center">{translate("analysing")}</p>
                    </div>
                ) : (
                    <div className="flex flex-col gap-4">
                        <p className="ft-b text-gray-700">{translate("conditions_intro")}</p>
                        <ul className="flex flex-col gap-3">
                            {CONDITIONS.map((condition) => (
                                <li key={condition} className="flex gap-3">
                                    <div className="bg-green-50 w-[28px] h-[28px] shrink-0 flex justify-center items-center rounded-full">
                                        <Check wh={16} color={"#059669"}/>
                                    </div>
                                    <div className="flex flex-col">
                                        <span className="ft-sm font-medium text-gray-900">{translate(`conditions.${condition}_title`)}</span>
                                        <span className="ft-sm text-gray-500">{translate(`conditions.${condition}_text`)}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <div className="flex flex-col gap-3">
                            {needsBothSides ? (
                                <>
                                    <Importfile
                                        name={translate("file_front")}
                                        titleFile={files.fileR?.name || ""}
                                        webcam={false}
                                        change={(e) => onFileChange("fileR", e)}
                                    />
                                    <Importfile
                                        name={translate("file_back")}
                                        titleFile={files.fileV?.name || ""}
                                        webcam={false}
                                        change={(e) => onFileChange("fileV", e)}
                                    />
                                </>
                            ) : (
                                <Importfile
                                    name={translate("file_single")}
                                    titleFile={files.fileR?.name || ""}
                                    webcam={false}
                                    change={(e) => onFileChange("fileR", e)}
                                />
                            )}
                        </div>
                        {errorMessage && <Banner type="alert">{errorMessage}</Banner>}
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} disabled={isUploading} onClick={onBack}>
                    {translate("back")}
                </Button>
                <Button
                    size={"LG"}
                    color={canImport && !isUploading ? "PRIMARY" : "DISABLED"}
                    disabled={!canImport || isUploading}
                    onClick={onImport}
                >
                    {translate(`options.${documentType}.import_button`)}
                </Button>
            </ModalFooter>
        </>
    );
};

export default DocumentImportStep;
